import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchBankOfHoursSucces = bankOfHours => ({
    type: actions.FETCH_BANK_OF_HOURS_SUCCESS,
    bankOfHours,
});

export const fetchBankOfHours = (employeeId) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get(`/timeSheet/generate/pointSheet/bi/bankHours/${employeeId}`)
    // .get(`/balanceHours/getAndUpdateBankHours/${employeeId}`)
    .then((response) => {
      dispatch(fetchBankOfHoursSucces(response.data));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject();
    });
};